<div class="container">
    <div class="row mt-3 mb-3">
        <div class="col">
            <div class="card">
                <form [formGroup]="routerTypesFormGroup" (ngSubmit)="onRouterTypeFormSubmit()">
                    <div class=" card-header ">
                        Router Type
                    </div>
                    <div class="card-body ">
                        <dl class="row ">
                            <dt class="col-sm-3 text-right align-middle ">
                                <label class="control-label col-form-label-sm ">router type name *</label>
                            </dt>
                            <dd class="col-sm-3">
                                <input type="input" class="form-control form-control-sm" [ngClass]="{'is-invalid': validationErrorsArray['name']}" formControlName="name" />
                                <div *ngIf="validationErrorsArray['identifier']" class="invalid-feedback">
                                    {{validationErrorsArray['name']}}
                                </div>
                            </dd>
                        </dl>
                        <dl class="row ">
                            <dt class="col-sm-3 text-right align-middle ">
                            <label class="control-label col-form-label-sm ">router type price *</label>
                        </dt>
                            <dd class="col-sm-3">
                                <input type="input" class="form-control form-control-sm" [ngClass]="{ 'is-invalid': validationErrorsArray['price'] }" formControlName="price" />
                                <div *ngIf="validationErrorsArray['price']" class="invalid-feedback">
                                    {{validationErrorsArray['price']}}
                                </div>
                            </dd>
                        </dl>
                        <dl class="row ">
                            <dt class="col-sm-3 text-right align-middle ">
                              <label class="control-label col-form-label-sm ">status *</label>
                          </dt>
                            <dd class="col-sm-3 ">
                                <select class="form-control form-control-sm " formControlName=status>
                                  <option *ngFor="let status of routerTypeStatusArray " [value]=status.value>
                                      {{status.label}}</option>
                              </select>
                            </dd>
                        </dl>
                        <dl class="row ">
                            <dt class="col-sm-3 text-right align-middle ">
                              <label class="control-label col-form-label-sm ">router manufacturer *</label>
                          </dt>
                            <dd class="col-sm-3 ">
                                <select class="form-control form-control-sm" [ngClass]="{ 'is-invalid': validationErrorsArray['routerManufacturer'] }" formControlName=routerManufacturer>
                                  <option *ngFor="let routerType of routerTypeVals " [value]="routerType.routerManufacturer.id ">
                                      {{routerType.routerManufacturer.name }}</option>
                              </select>
                                <div *ngIf="validationErrorsArray['identifier']" class="invalid-feedback">
                                    {{validationErrorsArray['routerManufacturer']}}
                                </div>
                            </dd>
                        </dl>
                    </div>
                    <div class="card-footer ">
                        <a class="btn btn-default btn-sm " href="/hardware/routers ">
                            <i class="fa fa-times "></i> <br /> Cancel
                        </a>
                        <button class="btn btn-primary btn-sm float-right " type="submit ">
                        <i class="fa fa-save "></i> <br />
                      Save
                    </button>
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>